import abbreviation from "@/constant/abbreviation";

export function dataURLtoFile(dataurl, filename) {
  let _arr = dataurl.split(","),
    mime = _arr[0].match(/:(.*?);/)[1],
    bstr = atob(_arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

function getStrLenShort(nameList) {
  let tempName = "";
  if (nameList.length > 0) {
    tempName = nameList[0];
    let temp = "";
    for (let i = 1; i < nameList.length; i++) {
      temp = nameList[i];
      if (tempName.length > temp.length) {
        tempName = temp;
      }
    }
  }
  return tempName;
}

function getCompanyAbbr(name) {
  let length = name.length;
  if (length <= 4) {
    return name;
  }
  let nameList = [];
  for (let i = 0; i < abbreviation.province.length; i++) {
    let prefix = abbreviation.province[i];
    if (name.startsWith(prefix)) {
      let nameSub = name.substring(prefix.length);
      nameList.push(nameSub);
    } else {
      nameList.push(name);
    }
  }
  name = getStrLenShort(nameList);

  let nameList1 = [];
  for (let i = 0; i < abbreviation.cities.length; i++) {
    let prefix = abbreviation.cities[i];
    if (name.startsWith(prefix)) {
      let nameSub = name.substring(prefix.length);
      nameList1.push(nameSub);
    } else {
      nameList1.push(name);
    }
  }
  name = getStrLenShort(nameList1);

  let nameList2 = [];
  for (let i = 0; i < abbreviation.companySuffixes.length; i++) {
    let suffix = abbreviation.companySuffixes[i];
    if (name.endsWith(suffix)) {
      let substring = name.substring(0, name.length - suffix.length);
      nameList2.push(substring);
    } else {
      nameList2.push(name);
    }
  }
  name = getStrLenShort(nameList2);

  if (name.includes("（")) {
    name = name.split("（")[0];
  }

  if (name.length > 4) {
    name = name.substring(0, 4);
  }
  return name;
}

export function creatLogo(name) {
  let company = getCompanyAbbr(name);
  let canvas = document.createElement("canvas");
  canvas.width = 200;
  canvas.height = 200;
  let ctx = canvas.getContext("2d");

  ctx.textBaseline = "middle";
  ctx.fillStyle = "#FF6A00";
  ctx.fillRect(0, 0, 200, 200);
  ctx.fillStyle = "#fff";

  if (company.length == 1) {
    ctx.font = '80px "微软雅黑"';
    ctx.fillText(company, 60, 110);
  } else if (company.length == 2) {
    ctx.font = '60px "微软雅黑"';
    ctx.fillText(company, 40, 110);
  } else if (company.length == 3) {
    ctx.font = '50px "微软雅黑"';
    ctx.fillText(company, 25, 110);
  } else if (company.length == 4) {
    ctx.font = '60px "微软雅黑"';
    ctx.fillText(company.substring(0, 2), 42, 72);
    ctx.fillText(company.substring(2, 4), 42, 148);
  }
  return canvas.toDataURL();
}

export function isUrlWithParam(url) {
  return !!url.match(/[\\?&]([^&]+)=([^&]+)/)
}


// 订单----------

export function randomBy(e,t) {
  e = e || 32
  let a = t.length
  let n = ""
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

export function randomString(e) {
  return randomBy(e,"abcdefghijkmnpqrstuvwxyz123456789")
}


/**
* Check if an element has a class
* @param {HTMLElement} elm
* @param {string} cls
* @returns {boolean}
*/
export function hasClass(ele, cls) {
return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
* Add class to element
* @param {HTMLElement} elm
* @param {string} cls
*/
export function addClass(ele, cls) {
if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
* Remove class from element
* @param {HTMLElement} elm
* @param {string} cls
*/
export function removeClass(ele, cls) {
if (hasClass(ele, cls)) {
  const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
  ele.className = ele.className.replace(reg, ' ')
}
}